import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import Auth0ProviderWithRedirectCallback from './components/Auth0ProviderWithRedirectCallback';
import config from './config.json';
import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
	<BrowserRouter
		getUserConfirmation={() => {
			// Passing empty callback to disable default browser prompt
		}}
	>
		<Auth0ProviderWithRedirectCallback
			connection={config.auth0.connection}
			domain={config.auth0.domain}
			clientId={config.auth0.clientId}
			audience={config.auth0.audience}
			redirectUri={window.location.origin}
			useRefreshTokens={true}
			cacheLocation="localstorage"
		>
			<App />
		</Auth0ProviderWithRedirectCallback>
	</BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
